module.exports = __webpack_public_path__ + "img/praiana.39619109.jpg";